import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  "pk_test_51LVOw9EIfyt9ggQYomBHtZkvxkzsMIglQhgdoNroCA8xaiX81Igi3hGuYgN9JelKwRya077xwHowtWRbHvnpXRod00F96FK9li"
);
